import { Component, OnInit, ViewChild } from '@angular/core';
import { Chart, ChartConfiguration, ChartData, ChartDataset, ChartType, TooltipItem } from 'chart.js';
import Annotation from 'chartjs-plugin-annotation';
import DatalabelsPlugin from 'chartjs-plugin-datalabels';
import DataLabelsPlugin from 'chartjs-plugin-datalabels';

import { BaseChartDirective } from 'ng2-charts';
import { RecentlyAddedModel } from 'src/app/models/Dashboard';
import { Item } from 'src/app/models/item';
import { AdminService } from 'src/app/services/admin.service';
import * as moment from 'moment';
import { DashboardService } from 'src/app/services/dashboard.service';
import { PolicyService } from 'src/app/services/policy.service';
import swal from 'sweetalert2';
import { LoaderService } from 'src/app/services/loader.service';
import { getGrowthRatio } from 'src/app/functions/validation-functions';
import { GeneralService } from 'src/app/services/general.service';
import { DashboardCustomerPanelComponent } from 'src/app/components/dashboard-customer-panel/dashboard-customer-panel.component';
import { DashboardAgentPanelComponent } from 'src/app/components/dashboard-agent-panel/dashboard-agent-panel.component';
import { DashboardResellerPanelComponent } from 'src/app/components/dashboard-reseller-panel/dashboard-reseller-panel.component';
import { DashboardSalesPanelComponent } from 'src/app/components/dashboard-sales-panel/dashboard-sales-panel.component';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent {
  @ViewChild(BaseChartDirective) chart: BaseChartDirective | undefined;
  @ViewChild(DashboardCustomerPanelComponent) dashboardCustomerPanelComponent!: DashboardCustomerPanelComponent;
  @ViewChild(DashboardAgentPanelComponent) dashboardAgentPanelComponent!: DashboardAgentPanelComponent;
  @ViewChild(DashboardResellerPanelComponent) dashboardResellerPanelComponent!: DashboardResellerPanelComponent;
  @ViewChild(DashboardSalesPanelComponent) dashboardSalesPanelComponent!: DashboardSalesPanelComponent;
  onBoardedAgent:number=0;
  onBoardedAgentRatio:number = 0;
  inProgressAgent:number=0;
  inProgressAgentRatio:number=0;
  blokedAgent:number=0;
  blokedAgentRatio:number=0;
  totalCustomers:number=0;
  totalCustomersRatio:number=0;
  chartDataDis:any=[];
  chartDataRes:any=[];
  chartDataAgn:any=[];
  chartDataCus:any=[];
  chartDataLeads:any=[];
  topPerfAgent:any=[];
  topRecentAgent:any=[];
  topPerfReseller:any=[];
  topRecentReseller:any=[];
  policySold:any=[];

  barChartLabel:any=[];
  barChartData1:any=[];
  barChartData2:any=[];
  colorArray:string[] = ["#EAFB86","#F7BC24","#F79824","#F45757","#EB6C99","#EF36DD","#8166AD","#345D9D","#5F36D3","#4FC3C7","#35ECB5","#81D065","#26AD85","#EDFFBA"]; 
  today = new Date();
  selectedStartDate:any = moment(this.today).add(-7, 'days').format();
  selectedEndDate:any = this.today;
  selectedDateRange:string="Past 7 Days";
  distributorDDLList:any=[];
  selectedDistributor:number=0;
  selectedAgentIds:string = '';
  policyDetails:any;
  showPolicyDetails:boolean = false;
  policyTypeList:{text:string,value:number}[] = [{text:"Both",value:2},{text:"Offline",value:1},{text:"Online",value:0}];
  policyType:number = 0;
  applyClicked = false
  totalLeads: number = 0;
  succeedLeads: number = 0;
  failedLeads: number = 0;
  pendingLeads: number = 0;
  customerLeadsCardList:any = [];
  constructor(private adminSevice:AdminService,private dashboardSevice:DashboardService,private policyService:PolicyService, private spinner: LoaderService, private gereralService:GeneralService) {
    Chart.register(Annotation);   
    this.isDateRangeChanged = true;
    this.selectedAgentIds = '';
    this.bindDashboardData();
  }

  graphdata: any[] = [];
  visibleColumnData: Item[] = [];
  visibleColumnsId:any[] = [];
  graphHeader :any[]=[];
  
  graphdataReseller: any[] = [];
  visibleColumnDataReseller: Item[] = [];
  visibleColumnsIdReseller:any[] = [];
  graphHeaderReseller :any[]=[];

  recentlyAdded:RecentlyAddedModel[]=[];
  policySoldCount:number = 0;
  policySoldRevenue:number = 0;
  policySoldCompanyList:any;
  agentList:Item[] = [];
  isDateRangeChanged:boolean = false;
  customerReminderList:any=[];
  resellerList:Item[] = [];
  distributorList:Item[] = [];
  originalAgentList:Item[] = [];
  ngOnInit(): void {
  
  }

  bindDashboardAgentData(){
    if(this.dashboardAgentPanelComponent != undefined){
      this.dashboardAgentPanelComponent.bindDashboardAgentData(moment(this.selectedStartDate).format('YYYY-MM-DD'),moment(this.selectedEndDate).format('YYYY-MM-DD'),this.policyType);
    }
  }

  bindAdminDashboardDistributorData(){
    let obj={
      DistributorId:this.selectedDistributor,
      ResellerId:0,
      AgentId:0,
      SystemCompanyId:1,
      StartDate:moment(this.selectedStartDate).format('YYYY-MM-DD'),
      EndDate:moment(this.selectedEndDate).format('YYYY-MM-DD')
    }
    this.dashboardSevice.GetAminDashboardDistributorData(obj).then((response)=> { 
      if(response?.isSuccess && response?.result?.length > 0)
      {
        for(let i=0;i<response?.result?.length;i++)
        {
          if(response.result[0] != null && response.result[0] != undefined && response.result[0] != "")
          {
            switch(i)
            {
              case 0 :
              this.chartDataRes= JSON.parse(response.result[i]);
              break;
              case 1 :
              this.chartDataAgn= JSON.parse(response.result[i]);
              break;
              case 2 :
              this.chartDataCus= JSON.parse(response.result[i]);
              break;
              case 3 :
              this.chartDataLeads= JSON.parse(response.result[i]);
              break;
              case 4 :
                this.policySold= JSON.parse(response.result[i]);            
              break;  
            }
            
          }
        }

        if(this.policySold && this.policySold.length > 0)
        {
          this.pieChartDataSummary= {
            labels: this.policySold.map((m:any) => {return m.insurance}),
            datasets: [
              {
                data: this.policySold.map((m:any) => {return m.value}),
                backgroundColor: this.colorArray, 
                borderColor: this.colorArray,
              },
            ],
          };
        }

          this.loadChart('res');
      }
    })
  }

  pieChartOptionsSummary: ChartConfiguration['options'] = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
        position: 'right',
      },
      
      datalabels: {
        formatter: (value: any, ctx: any) => {
          if (ctx.chart.data.labels) {
            return ctx.chart.data.labels[ctx.dataIndex];
          }
        },
      },
    },
  };
  pieChartLabelsSummary: string[] = ['Red', 'Green', 'Blue','Yellow']; // Example labels
  pieChartTypeSummary: ChartType = 'pie';
  pieChartPluginsSummary = [DatalabelsPlugin];
  pieChartDataSummary: ChartData<'pie', number[], string | string[]> = {
    labels: [],
    datasets: [
      {
        data: [],
        backgroundColor: ['#54B66F', '#FFAD2A'], 
        borderColor: ['#54B66F', '#FFAD2A'],
      },
    ],
  };
  
  
  public pieChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
        position: 'right',
      },
      
      datalabels: {
        formatter: (value: any, ctx: any) => {
          if (ctx.chart.data.labels) {
            return ctx.chart.data.labels[ctx.dataIndex];
          }
        },
      },
    },
  };
  public pieChartData: ChartData<'pie', number[], string | string[]> = {
    labels: [['Commission', 'Earned'], ['Commission', 'Pending']],
    datasets: [
      {
        data: [10250, 5250,5000],
        backgroundColor: ['#54B66F', '#FFAD2A'], 
        borderColor: ['#54B66F', '#FFAD2A'],
      },
    ],
  };
  pieChartLabels: string[] = ['Red', 'Green', 'Blue','Yellow']; // Example labels
  public pieChartType: ChartType = 'pie';
  public pieChartPlugins = [DatalabelsPlugin];
  

  activeTab: number = 1;
  activeTabs:number = 5;
  activeTabs1:number = 99;
  changeTab(tab: number) {
    this.activeTab = tab;
  }
  changeTabs(tab: number) {
    this.activeTabs = tab;
  }

  //Line chart Summary
  public barChartOptionsSummary: ChartConfiguration['options'] = {
    responsive: true,
    // We use these empty structures as placeholders for dynamic theming.
    scales: {
      x: {
        // display: true,
        grid: {
          display: false, // Hide the x-axis grid lines
        },
                
        ticks: {
          stepSize: 50, // Set the spacing between grid lines
        },
      },
      y: {
        
        min: 0,
        
        ticks: {
          stepSize: 30, // Set the spacing between grid lines
        },
        title: {
          display: true,
          text: 'Count',
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
      },
      datalabels: {
        anchor: 'end',
        align: 'end',
      },
    },
  };
  public barChartTypeSummary: ChartType = 'bar';
  public barChartPluginsSummary = [DataLabelsPlugin];
  public barChartDataSummary: ChartData<'bar'> = {
    //labels: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct'],
    labels: this.barChartLabel,
    datasets: [
      { 
        //data: [80, 85, 100, 95, 86, 105, 90, 110, 93], 
        data: this.barChartData1,
        label: 'Previous Year(2022)', 
        backgroundColor: ['#10A0C1'], 
        borderColor: ['#10A0C1'],
        
      },
      { 
        //data: [35, 45, 40, 25, 50, 55, 56, 58, 47], 
        data: this.barChartData2,
        label: 'Current Year(2023)',
        backgroundColor: ['#FFAD2A'],
        borderColor: ['#FFAD2A']
      },        
    ],
  };


  // line charts
  public barChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    // We use these empty structures as placeholders for dynamic theming.
    scales: {
      x: {
        // display: true,
        grid: {
          display: false, // Hide the x-axis grid lines
        },
                
        ticks: {
          stepSize: 50, // Set the spacing between grid lines
        },
      },
      y: {
        
        min: 0,
        
        ticks: {
          stepSize: 30, // Set the spacing between grid lines
        },
        title: {
          display: true,
          text: '₹ (thousands)',
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
      },
      datalabels: {
        anchor: 'end',
        align: 'end',
      },
    },
  };
  public barChartType: ChartType = 'bar';
  public barChartPlugins = [DataLabelsPlugin];
  public barChartData: ChartData<'bar'> = {
    //labels: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct'],
    labels: this.barChartLabel,
    datasets: [
      { 
        //data: [80, 85, 100, 95, 86, 105, 90, 110, 93], 
        data: this.barChartData1,
        label: 'Previous Year(2022)', 
        backgroundColor: ['#10A0C1'], 
        borderColor: ['#10A0C1'],
        
      },
      { 
        //data: [35, 45, 40, 25, 50, 55, 56, 58, 47], 
        data: this.barChartData2,
        label: 'Current Year(2023)',
        backgroundColor: ['#FFAD2A'],
        borderColor: ['#FFAD2A']
      },        
    ],
  };
  // Line Charts
  private newLabel? = 'New label'; 

  public lineChartData: ChartConfiguration['data'] = {
    datasets: [
      {
        data: [20, 42, 40, 60, 41, 82, 62, 85],
        label: 'Series A',
        backgroundColor: '#9515181A',

        borderColor: '#10A0C1',
        pointBackgroundColor: 'rgba(148,159,177,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: '#10A0C1',
        borderWidth: 1.5,
        fill: 'origin',
      }
    ],
    labels: ['January', 'February', 'March', 'April', 'May', 'June'],
  };

  public lineChartDataPolicySold: ChartConfiguration['data'] = {
    datasets: [
      {
        data: [],
        label: 'Series A',
        backgroundColor: '#9515181A',        
        borderColor: '#10A0C1',
        pointBackgroundColor: 'rgba(148,159,177,1)',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: '#10A0C1',
        borderWidth: 1.5,
        fill: 'origin',
      }as CustomChartDataset
    ],
    labels: [],
  };

  public lineChartOptionsPolicySold: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false,
    elements: {
      line: {
        tension: 0.38,
      },
    },
    scales: {
      // We use this empty structure as a placeholder for dynamic theming.
      x: {
        grid: {
          display: false, // Hide the x-axis grid lines
        },
        ticks: {
          stepSize: 30, // Set the spacing between grid lines
        },
      },
      y: {
        position: 'left',
        grid: {
          display: false, // Hide the x-axis grid lines
        },
        ticks: {
          stepSize: 20, // Set the spacing between grid lines
        },
      },
      y1: {
        display: false,
        position: 'right',
        grid: {
          display: false,
          color: 'rgba(255,0,0,0.3)',
        },
        ticks: {
          color: 'red',
        },
      },
    },

    plugins: {
      legend: { display: false },
      annotation: {
        annotations: [
          {
            type: 'line',
            scaleID: 'x',
            // value: 'March',
            // borderColor: 'orange',
            // borderWidth: 2,
            label: {
              display: true,
              position: 'center',
              color: 'orange',
              content: 'LineAnno',
              font: {
                weight: 'bold',
              },
            },
          },
        ],
      },
      tooltip: {
        displayColors: false,
        callbacks: {
          label: function (tooltipItem: TooltipItem<'line'>) {
            let dataset = tooltipItem.dataset as CustomChartDataset;
            let value = tooltipItem.raw; // Get the data value
            let extraInfo = new Intl.NumberFormat('en-US').format(parseInt((dataset.customData ? dataset.customData[tooltipItem.dataIndex] : '0')??'0'));
            return [
              `Count  : ${value}`,
              `Revenue: ${extraInfo}`
            ];
          }
        }
      }
    },
  };

  public lineChartOptions: ChartConfiguration['options'] = {
    elements: {
      line: {
        tension: 0.38,
      },
    },
    scales: {
      // We use this empty structure as a placeholder for dynamic theming.
      x: {
        grid: {
          display: false, // Hide the x-axis grid lines
        },
        ticks: {
          stepSize: 30, // Set the spacing between grid lines
        },
      },
      y: {
        position: 'left',
        grid: {
          display: false, // Hide the x-axis grid lines
        },
        ticks: {
          stepSize: 20, // Set the spacing between grid lines
        },
      },
      y1: {
        display: false,
        position: 'right',
        grid: {
          display: false,
          color: 'rgba(255,0,0,0.3)',
        },
        ticks: {
          color: 'red',
        },
      },
    },

    plugins: {
      legend: { display: false },
      annotation: {
        annotations: [
          {
            type: 'line',
            scaleID: 'x',
            // value: 'March',
            // borderColor: 'orange',
            // borderWidth: 2,
            label: {
              display: true,
              position: 'center',
              color: 'orange',
              content: 'LineAnno',
              font: {
                weight: 'bold',
              },
            },
          },
        ],
      },
    },
  };

  public lineChartType: ChartType = 'line';

  public barChartPolicyData: ChartData<'bar'> = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep'],
    datasets: [
      { 
        data: [35, 41, 37, 28, 45, 48, 52, 53, 41], 
        label: 'Previous Year(2022)', 
        backgroundColor: ['#FEB019'], 
        borderColor: ['#FEB019'],
      },
        
    ],
  };

  public barChartPolicyOptions: ChartConfiguration['options'] = {
    responsive: true,
    // We use these empty structures as placeholders for dynamic theming.
    scales: {
      x: {
        
        // display: true,
        grid: {
          display: false, // Hide the x-axis grid lines
        },
               
        ticks: {
          stepSize: 20, // Set the spacing between grid lines
          
        },
      },
      y: {
        
        min: 0,
        
        ticks: {
          stepSize: 10, // Set the spacing between grid lines
        },
        title: {
          display: true,
          text: '₹ (thousands)',
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        position: 'bottom',
      },
      datalabels: {
        display: false, // Hide the data labels (bar values)
      },
    },
  };

  uniqueMonthLabel = (data:any) => {
    let unique_values = data
        .map((item:any) => item.month)
        .filter(
            (value:any, index:number, current_value:any) => current_value.indexOf(value) === index
        );
    return unique_values;
  };
  uniqueYear = (data:any) => {
    let unique_values = data
        .map((item:any) => parseInt(item.year))
        .filter(
            (value:any, index:number, current_value:any) => current_value.indexOf(value) === index
        );
    return unique_values.sort();
  };

  loadChart(charFor:string){
    console.log();
    let years:number[] = [];
    let label:any=[];
    let currentYearData:any=[];
    let previousYearData:any=[];
    switch(charFor){
      case 'res':
        years = this.uniqueYear(this.chartDataDis);
        label =  this.uniqueMonthLabel(this.chartDataRes);//this.chartDataRes.map((m:any)=>{return m.month}); //Object.keys(this.chartDataDis); 
        previousYearData = this.chartDataRes.filter((f:any)=>{return f.year == years[0]}).map((m:any)=>{return  parseFloat(m.value)});//Object.values(this.chartDataDis);
        currentYearData = this.chartDataRes.filter((f:any)=>{return f.year == years[1]}).map((m:any)=>{return  parseFloat(m.value)});
        break;
      case 'agn':
        years = this.uniqueYear(this.chartDataAgn);
        label =  this.uniqueMonthLabel(this.chartDataAgn);//this.chartDataAgn.map((m:any)=>{return m.month}); //Object.keys(this.chartDataDis); 
        previousYearData = this.chartDataAgn.filter((f:any)=>{return f.year == years[0]}).map((m:any)=>{return  parseFloat(m.value)});//Object.values(this.chartDataDis);
        currentYearData = this.chartDataAgn.filter((f:any)=>{return f.year == years[1]}).map((m:any)=>{return  parseFloat(m.value)});
        break;
      case 'cus':
        years = this.uniqueYear(this.chartDataCus);
        label =  this.uniqueMonthLabel(this.chartDataCus);//this.chartDataCus.map((m:any)=>{return m.month}); //Object.keys(this.chartDataDis); 
        previousYearData = this.chartDataCus.filter((f:any)=>{return f.year == years[0]}).map((m:any)=>{return  parseFloat(m.value)});//Object.values(this.chartDataDis);
        currentYearData = this.chartDataCus.filter((f:any)=>{return f.year == years[1]}).map((m:any)=>{return  parseFloat(m.value)});
        break;
      case 'lds':
        years = this.uniqueYear(this.chartDataLeads);
        label =  this.uniqueMonthLabel(this.chartDataLeads);//this.chartDataDis.map((m:any)=>{return m.month}); //Object.keys(this.chartDataDis); 
        previousYearData = this.chartDataLeads.filter((f:any)=>{return f.year == years[0]}).map((m:any)=>{return  parseFloat(m.value)});//Object.values(this.chartDataDis);
        currentYearData = this.chartDataLeads.filter((f:any)=>{return f.year == years[1]}).map((m:any)=>{return  parseFloat(m.value)});
        break;
        
    }
    this.barChartDataSummary = {
      //labels: ['Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct'],
      labels: label,
      datasets: [
        { 
          //data: [80, 85, 100, 95, 86, 105, 90, 110, 93], 
          data: previousYearData,
          label: 'Previous Year('+years[0]+')', 
          backgroundColor: ['#10A0C1'], 
          borderColor: ['#10A0C1'],
        },
        { 
          //data: [35, 45, 40, 25, 50, 55, 56, 58, 47], 
          data: currentYearData,
          label: 'Current Year('+years[1]+')',
          backgroundColor: ['#FFAD2A'],
          borderColor: ['#FFAD2A']
        },        
      ],
  }
  }

  bindLineChartDataPolicySold(policyTypeCahnge=false){
    if(this.dashboardSalesPanelComponent != undefined){
      this.dashboardSalesPanelComponent.isDateRangeChanged = this.isDateRangeChanged;
      this.dashboardSalesPanelComponent.bindLineChartDataPolicySoldCall(moment(this.selectedStartDate).format('YYYY-MM-DD'),moment(this.selectedEndDate).format('YYYY-MM-DD'),this.policyType,policyTypeCahnge);
      this.isDateRangeChanged = false;
    }
  }
  
  async onPolicyTypeCheck(){
    this.bindDashboardData();
    this.bindLineChartDataPolicySold(true);
  }

  async getLeadsStatusCustomerDashboard(){
    if(this.dashboardCustomerPanelComponent != undefined){
      this.dashboardCustomerPanelComponent.getLeadsStatusCustomerDashboard(moment(this.selectedStartDate).format('YYYY-MM-DD'),moment(this.selectedEndDate).format('YYYY-MM-DD'));
    }
  } 

  async getCustomerLeadsCardDashboard(){
    if(this.dashboardCustomerPanelComponent != undefined){
      this.dashboardCustomerPanelComponent.getCustomerLeadsCardDashboard(moment(this.selectedStartDate).format('YYYY-MM-DD'),moment(this.selectedEndDate).format('YYYY-MM-DD'));
    }
  }  

  async onDateRangeChange(selectedValues:any) {
    if(selectedValues?.length > 0){
      let dataArray = selectedValues.split('::');
      if(dataArray?.length > 2){
        this.selectedStartDate = dataArray[0];
        this.selectedEndDate = dataArray[1];
        this.selectedDateRange = dataArray[2];

        this.isDateRangeChanged  = true;
        this.selectedAgentIds = '';
        setTimeout(() => {
          this.bindDashboardData();
        }, 100);
      }
    }    
  }

  GetTop5ResDashboardData(){
    if(this.dashboardResellerPanelComponent != undefined){
      this.dashboardResellerPanelComponent.GetTop5ResDashboardData(moment(this.selectedStartDate).format('YYYY-MM-DD'),moment(this.selectedEndDate).format('YYYY-MM-DD'),this.policyType);
    }
  }

  ngAfterViewInit() {
    this.bindDashboardData();  
  }

  bindDashboardData(policyTypeCahnge=false){
    this.getCustomerLeadsCardDashboard();
    this.getLeadsStatusCustomerDashboard();
    this.bindDashboardAgentData();
    this.GetTop5ResDashboardData();
    this.bindLineChartDataPolicySold(policyTypeCahnge);
  }

  async onPolicyTypeCheckOutput(event:any){
    this.policyType = event;
    this.bindDashboardData(true);
  }
}

interface CustomChartDataset extends ChartDataset<'line', number[]> {
  customData?: string[];
}